import React__default from 'react';
import { Avatar } from '@deal/components';
import MessageBubble from '../../../MessageBubble/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import HeroWithImage from '../../components/HeroWithImage/index.js';
import CallToAction from '../../components/CallToAction/index.js';
import { useReferralConsumerMessageQuery } from './ReferralConsumerMessage.generated.js';
import styles from './styles.css.js';

var ReferralConsumerMessage = function ReferralConsumerMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded,
      richCard = _a.richCard;
  var expertId = richCard.expertId;
  var richCardEventEmitter = useRichCardEventEmitter();

  var _b = useReferralConsumerMessageQuery({
    variables: {
      vanityIdOrId: expertId
    }
  }),
      data = _b.data,
      loading = _b.loading;

  if (loading) {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself,
      onLoaded: onLoaded
    }, "Loading...");
  } else if (data && data.findExpert) {
    var _c = data.findExpert,
        displayName = _c.displayName,
        shortName = _c.shortName,
        id_1 = _c.id,
        expertAttributes = _c.expertAttributes,
        expertProfile = _c.expertProfile;
    data.findExpert.expertAttributes;
    var name_1 = displayName;
    var category = expertAttributes && expertAttributes.categories[0];
    var banner = category && category.contentAssets.bannerImages[0];
    var categoryName = category && category.singularDisplayName;
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement(HeroWithImage, {
      imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
      heroLabel: React__default.createElement(React__default.Fragment, null, ' ', expertProfile && expertProfile.profilePhoto && React__default.createElement("div", {
        className: styles.avatarContainer
      }, React__default.createElement(Avatar, {
        size: 80,
        name: name_1,
        src: expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles.name
      }, name_1), React__default.createElement("div", {
        className: styles.category
      }, "Your ", categoryName, " Expert"))
    }), React__default.createElement(CallToAction, {
      onClick: function onClick() {
        return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
          type: ConsumerRichCardEvents.OPEN_REFERRAL_MODAL,
          entryPoint: 'expert-referral-rich-card',
          businessUserId: id_1
        });
      }
    }, "Share " + shortName + "'s profile"));
  } else {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Error loading message!");
  }
};

export default ReferralConsumerMessage;
//# sourceMappingURL=index.js.map
